<template>
  <div>
    <modal-loan-edit
      v-if="pdfData"
      :loan-data="{ id: 0 }"
      :inEdit="inEdit"
      :client-id="pdfData.client_id"
      @refetch-data="refetchNewestData"
    ></modal-loan-edit>
    <template v-if="pdfData && pdfData.id">
      <modal-add-reject
        @refetch-newest-data="refetchNewestData"
        @refetch-supplier-info="refetchSupplierInfo"
        :search-record-id="pdfData.id"
        :isEdit="isRejectEdit"
        :rejectData="rejectData"
        :rejectLogs="rejectLogs"
      ></modal-add-reject>
      <modal-add-account
        @refetch-newest-data="refetchNewestData"
        @refetch-supplier-info="refetchSupplierInfo"
        :search-record-id="pdfData.id"
        :isEdit="isAccountEdit"
        :accountData="accountData"
        :accountLogs="accountLogs"
      ></modal-add-account>
    </template>
    <!-- modal PDF-->
    <b-modal
      id="modal-PDF"
      hide-footer
      hide-header
      cancel-variant="outline-secondary"
      centered
      size="lg"
      title=""
      :ok-disabled="false"
      @show="onModalShow"
    >
      <b-card no-body class="bgColor3 mt-1">
        <b-card-body class="p-2">
          <div v-if="pdfData" class="pdf-info">
            <div class="bg-logo"></div>
            <!-- 水印層 -->
            <div class="watermark-container" ref="watermarkContainer">
              <div class="watermark-pattern diagonal-pattern">
                <div
                  v-for="i in dynamicWatermarkCount"
                  :key="i"
                  class="watermark-item diagonal-item"
                  :class="{
                    'watermark-odd': i % 2 === 1,
                    'watermark-even': i % 2 === 0,
                  }"
                  :style="getDiagonalPosition(i)"
                >
                  <div
                    class="watermark-text diagonal-text"
                    :style="getWatermarkColor(i)"
                  >
                    {{ getSupplierName }} {{ getSearcherInfo }}
                  </div>
                </div>
              </div>
            </div>

            <!-- 浮動顏色選擇器 - 測試用 (已隱藏) -->
            <!--
            <div class="floating-color-selector">
              <div class="color-selector-panel">
                <h6>水印顏色測試</h6>
                <div class="color-group">
                  <label>奇數水印: {{ testColors.odd }}</label>
                  <div class="color-input-row">
                    <input
                      type="color"
                      v-model="testColors.odd"
                      @input="updateWatermarkColors"
                    />
                    <div class="color-preview" :style="{ backgroundColor: testColors.odd }"></div>
                  </div>
                  <div class="opacity-control">
                    <span>透明度: {{ testOpacity.odd }}</span>
                    <input
                      type="range"
                      min="0.1"
                      max="1"
                      step="0.1"
                      v-model="testOpacity.odd"
                      @input="updateWatermarkColors"
                    />
                  </div>
                </div>
                <div class="color-group">
                  <label>偶數水印: {{ testColors.even }}</label>
                  <div class="color-input-row">
                    <input
                      type="color"
                      v-model="testColors.even"
                      @input="updateWatermarkColors"
                    />
                    <div class="color-preview" :style="{ backgroundColor: testColors.even }"></div>
                  </div>
                  <div class="opacity-control">
                    <span>透明度: {{ testOpacity.even }}</span>
                    <input
                      type="range"
                      min="0.1"
                      max="1"
                      step="0.1"
                      v-model="testOpacity.even"
                      @input="updateWatermarkColors"
                    />
                  </div>
                </div>
                <button @click="resetColors" class="btn btn-sm btn-secondary">重置</button>
              </div>
            </div>
            -->
            <div class="top mt-2 mb-3">
              <div
                class="d-flex flex-wrap flex-sm-nowrap justify-content-between"
              >
                <div class="">
                  <div
                    v-if="pdfData.client && pdfData.client.id_number"
                    class="d-flex mobile-w100 align-items-center mb-1"
                  >
                    <span>身分證號碼：</span
                    ><span>{{
                      pdfData.client && pdfData.client.id_number
                    }}</span>
                  </div>
                  <!-- <div v-if="pdfData.client && pdfData.client.name_cn" class="d-flex mobile-w100 align-items-center">
                <span>中文姓名：</span><span>{{ pdfData.client && pdfData.client.name_cn }}</span>
              </div>
              <div v-if="pdfData.client && pdfData.client.name_en" class="d-flex mobile-w100 align-items-center">
                <span>英文姓名：</span><span>{{ pdfData.client && pdfData.client.name_en }}</span>
              </div> -->
                  <div class="d-flex flex-wrap mobile-w100 align-items-center">
                    <span>報告日期：</span
                    ><span>{{ pdfData.report_date }}</span>
                  </div>
                  <div v-if="bankruptcyInfo && bankruptcyInfo.has_records" class="d-flex flex-wrap mobile-w100 align-items-center mt-2">
                    <span>公共記錄資料</span
                    >
                  </div>
                  <div
                    v-if="bankruptcyInfo && bankruptcyInfo.has_records"
                    class="d-flex flex-wrap mobile-w100 align-items-center mt-1 p-2  justify-content-center"
                    style="background-color: rgba(255, 255, 255, 0.6) !important; border-radius: 0px; padding: 10px !important; position: relative; z-index:10;"
                  >
                    <div class="d-flex align-items-center">
                      <span
                        class="bankruptcy-info-text"
                        @click="showBankruptcyModal"
                        :title="'點擊查看 ' + bankruptcyInfo.id_prefix + ' 的詳細破產記錄'"
                      >
                        可能相關的破產記錄 ({{ bankruptcyInfo.count }})
                      </span>
                      <div
                        v-if="bankruptcyLoading"
                        class="ml-2"
                      >
                        <b-spinner small variant="secondary"></b-spinner>
                      </div>
                    </div>
                  </div>
                </div>
                <!--

              <div class="d-flex mobile-w100 align-items-start">
                  <span>數據日期：</span
                ><span>{{
                  `${pdfData.start_period} - ${pdfData.end_period}`
                }}</span>
              </div> -->
                <div class="mt-1 mt-sm-0">
                  <div
                    class="d-flex flex-wrap mobile-w100 align-items-center mb-1"
                  >
                    <span>搜尋次數：</span><span>{{ number_of_search }}</span>
                  </div>
                  <div class="d-flex flex-wrap mobile-w100 align-items-center">
                    <span>上傳次數：</span><span>{{ number_of_loan }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="middle mb-3">
              <div class="d-flex align-items-center justify-content-between">
                <p class="title-size">拒絕記錄</p>
                <b-button class="mb-2" @click="triggerAddReject"
                  >新增拒絕記錄</b-button
                >
              </div>
              <b-table
                ref="refRejectRecordTable"
                class="position-relative in_bg3"
                :tbody-tr-class="deleteLine"
                :items="pdfData.reject_records"
                responsive
                :fields="rejectTableColumns"
                primary-key="id"
                show-empty
                empty-text="未找到匹配的記錄"
              >
                <template #cell(record_date)="data">
                  <div v-if="data.item.record_date">
                    {{ getCorrectDateTime(data.item.record_date, true) }}
                  </div>
                  <div v-else>
                    {{ getCorrectDateTime(data.item.insert_date, true) }}
                  </div>
                </template>
                <template #cell(reject_option)="data">
                  {{ data.item.reject_option.name }} </template
                >=
                <template #cell(actions)="data">
                  <b-dropdown
                    v-if="
                      data.item.supplier_id == user_supplier_id &&
                      data.item.status.id < 2
                    "
                    class="action-trigger-btn"
                    :right="$store.state.appConfig.isRTL"
                  >
                    <template #button-content class="">
                      <feather-icon
                        icon="EyeIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </template>

                    <b-dropdown-item
                      v-if="ability.can('update', 'reject') || true"
                      @click="triggerEditReject(data.item)"
                    >
                      <feather-icon icon="EditIcon" />
                      <span class="align-middle ml-50">修改資料</span>
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="ability.can('delete', 'reject') || true"
                      @click="removeItem('reject', data.item)"
                    >
                      <feather-icon icon="Trash2Icon" />
                      <span class="align-middle ml-50">刪除記錄</span>
                    </b-dropdown-item>
                  </b-dropdown>
                  <div class="" v-else>- -</div>
                </template>
              </b-table>
              <div class="mx-2 mt-1 mb-2">
                <b-row>
                  <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-start"
                  >
                    <span class="text-muted"
                      >在{{ rejectDataMeta.of }}個記錄中，正在顯示
                      {{ rejectDataMeta.from }} 至
                      {{ rejectDataMeta.to }}個記錄</span
                    >
                  </b-col>
                  <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  >
                    <b-pagination
                      v-model="rejectCurrentPage"
                      :total-rows="totalRejects"
                      :per-page="rejectPerPage"
                      first-number
                      last-number
                      class="mb-0 mt-1 mt-sm-0"
                      prev-class="prev-item"
                      next-class="next-item"
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </div>
            </div>
            <hr class="w-100" />

            <div class="middle mb-3">
              <div
                class="d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-between mb-1"
              >
                <p class="mb-0 title-size">
                  {{
                    pdfData.extra_loan_record
                      ? "完整財務狀況"
                      : "個人財務狀況（半年內）"
                  }}<b-button
                    v-if="
                      !pdfData.extra_loan_record &&
                      pdfData.extra_loan_record_button
                    "
                    class="ml-sm-1 mb-1 mb-sm-0 mobile-w100"
                    variant="primary"
                    @click="buyExtraRecords(1)"
                    >完整財務狀況（半年外）</b-button
                  >
                </p>
                <div class="d-flex flex-wrap flex-sm-nowrap mt-1 mt-sm-0">
                  <b-button class="mobile-w100" @click="triggerCreateLoan"
                    >新增貸款</b-button
                  >
                </div>
              </div>
              <b-table
                ref="refSearchLoanTable"
                class="position-relative in_bg3"
                :items="pdfData.loan_record"
                responsive
                :fields="loanTableColumns"
                primary-key="id"
                show-empty
                empty-text="未找到匹配的記錄"
              >
                <template #cell(is_monthly)="data">
                  {{ data.item.is_monthly ? "月供" : "半月供" }}
                </template>
              </b-table>

              <div class="mx-2 mt-1 mb-2">
                <b-row>
                  <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-start"
                  >
                    <span class="text-muted"
                      >在{{ loanDataMeta.of }}個記錄中，正在顯示
                      {{ loanDataMeta.from }} 至
                      {{ loanDataMeta.to }}個記錄</span
                    >
                  </b-col>
                  <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  >
                    <b-pagination
                      v-model="loanCurrentPage"
                      :total-rows="totalLoans"
                      :per-page="loanPerPage"
                      first-number
                      last-number
                      class="mb-0 mt-1 mt-sm-0"
                      prev-class="prev-item"
                      next-class="next-item"
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </div>
            </div>
            <hr class="w-100" />

            <div class="middle mb-3">
              <div
                class="d-flex align-items-center justify-content-between mb-1"
              >
                <p class="mb-0 title-size">帳務記錄</p>
                <b-button class="" @click="triggerAddAccount"
                  >新增帳務記錄</b-button
                >
              </div>
              <b-table
                ref="refAccountRecordTable"
                :tbody-tr-class="deleteLine"
                class="position-relative in_bg3"
                :items="pdfData.account_records"
                responsive
                :fields="accountTableColumns"
                primary-key="id"
                show-empty
                empty-text="未找到匹配的記錄"
              >
                <template #cell(record_date)="data">
                  <div v-if="data.item.record_date">
                    {{ getCorrectDateTime(data.item.record_date, true) }}
                  </div>
                  <div v-else>
                    {{ getCorrectDateTime(data.item.insert_date, true) }}
                  </div>
                </template>
                <template #cell(account_option)="data">
                  <div v-if="data.item.account_option.id == '1'">
                    <div class="bad-debts">
                      {{ data.item.account_option.name }}
                    </div>
                  </div>
                  <div v-else>{{ data.item.account_option.name }}</div>
                </template>
                <template #cell(actions)="data">
                  <b-dropdown
                    v-if="
                      data.item.supplier_id == user_supplier_id &&
                      data.item.status.id < 2
                    "
                    class="action-trigger-btn"
                    :right="$store.state.appConfig.isRTL"
                  >
                    <template #button-content class="">
                      <feather-icon
                        icon="EyeIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </template>

                    <b-dropdown-item
                      v-if="ability.can('update', 'account') || true"
                      @click="triggerEditAccount(data.item)"
                    >
                      <feather-icon icon="EditIcon" />
                      <span class="align-middle ml-50">修改資料</span>
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="ability.can('delete', 'account') || true"
                      @click="removeItem('account', data.item)"
                    >
                      <feather-icon icon="Trash2Icon" />
                      <span class="align-middle ml-50">刪除記錄</span>
                    </b-dropdown-item>
                  </b-dropdown>
                  <div v-else>- -</div>
                </template>
              </b-table>

              <div class="mx-2 mt-1 mb-2">
                <b-row>
                  <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-start"
                  >
                    <span class="text-muted"
                      >在{{ accountDataMeta.of }}個記錄中，正在顯示
                      {{ accountDataMeta.from }} 至
                      {{ accountDataMeta.to }}個記錄</span
                    >
                  </b-col>
                  <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  >
                    <b-pagination
                      v-model="accountCurrentPage"
                      :total-rows="totalAccounts"
                      :per-page="accountPerPage"
                      first-number
                      last-number
                      class="mb-0 mt-1 mt-sm-0"
                      prev-class="prev-item"
                      next-class="next-item"
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </div>
            </div>

            <!-- hide -->
            <div class="middle mb-3" v-if="false">
              <p class="mb-0 title-size">過往搜尋記錄</p>
              <b-table
                ref="refSearchStatisticTable"
                class="position-relative in_bg3"
                :items="pdfData.statistic_record"
                responsive
                :fields="statisticTableColumns"
                primary-key="id"
                show-empty
                foot-clone
                empty-text="未找到匹配的記錄"
              >
                <template #foot(company_name_cn)> 總查看次數 </template>
                <template #foot(weekly)>
                  {{ totalWeekly }}
                </template>
                <template #foot(monthly)>
                  {{ totalMonthly }}
                </template>
                <template #foot(biannual)>
                  {{ totalBiannual }}
                </template>
              </b-table>
            </div>
            <!-- end hide -->

            <!-- hide -->
            <!-- <hr class="w-100"/> -->
            <div class="bottom" v-if="false">
              <div class="d-flex align-items-center justify-content-between">
                <p class="mb-0 title-size">
                  {{
                    pdfData.extra_search_record
                      ? "所有搜尋詳情"
                      : "15日搜尋詳情"
                  }}
                </p>
              </div>
              <b-table
                ref="refOldSearchDetailTable"
                class="position-relative in_bg3"
                :items="pdfData.detail_record"
                responsive
                :fields="searchDetailColumns"
                primary-key="id"
                show-empty
                empty-text="未找到匹配的記錄"
              >
                <!-- Column: search_date -->
                <template #cell(search_date)="data">
                  <div class="d-flex" style="width: 160px">
                    {{ getCorrectDateTime(data.item.search_date) }}
                    <b-badge
                      v-if="data.item.is_view_record"
                      variant="info"
                      class="ml-1"
                      size="sm"
                    >
                      查看
                    </b-badge>
                  </div>
                </template>
              </b-table>
            </div>
            <!-- end hide -->

            <hr class="w-100" />
            <div class="">
              <div class="d-flex align-items-center justify-content-between">
                <p class="mb-0 title-size">
                  {{
                    pdfData.extra_search_record
                      ? "信貸機構搜尋"
                      : "信貸機構搜尋(15天內)"
                  }}
                  <b-button
                    v-if="
                      !pdfData.extra_search_record &&
                      pdfData.extra_search_record_button
                    "
                    variant="primary"
                    class="ml-sm-1"
                    @click="buyExtraRecords(0)"
                    >完整搜尋（15天外）</b-button
                  >
                </p>
              </div>
              <b-table
                ref="refSearchDetailTable"
                class="position-relative in_bg3 search_detail_tb"
                :items="pdfData.new_search_records"
                responsive
                :fields="newSearchDetailColumns"
                primary-key="id"
                show-empty
                empty-text="未找到匹配的記錄"
              >
                <!-- Column: search_date -->
                <template #cell(date)="data">
                  {{ getCorrectDateTime(data.item.date, true) }}
                </template>
                <!-- Column: description -->
                <template #cell(show_details)="row">
                  <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                    {{ row.detailsShowing ? "隱藏" : "顯示" }}
                  </b-button>
                </template>

                <template #row-details="data">
                  <b-table
                    class="position-relative in_bg3 w-100"
                    :items="data.item.search_records"
                    thead-class="hidden_header"
                    responsive
                    :fields="searchDetailColumns"
                    primary-key="id"
                    show-empty
                    empty-text="未找到匹配的記錄"
                  >
                    <template #cell(search_date)="data2">
                      {{ getCorrectDateTime(data2.item.search_date, true) }}
                      <b-badge
                        v-if="data2.item.is_view_record"
                        variant="info"
                        class="ml-1"
                        size="sm"
                      >
                        查看
                      </b-badge>
                    </template>
                  </b-table>
                </template>
              </b-table>

              <div class="mx-2 mt-1 mb-2">
                <b-row>
                  <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-start"
                  >
                    <span class="text-muted"
                      >在{{ detailDataMeta.of }}個記錄中，正在顯示
                      {{ detailDataMeta.from }} 至
                      {{ detailDataMeta.to }}個記錄</span
                    >
                  </b-col>
                  <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  >
                    <b-pagination
                      v-model="detailCurrentPage"
                      :total-rows="totalDetails"
                      :per-page="detailPerPage"
                      first-number
                      last-number
                      class="mb-0 mt-1 mt-sm-0"
                      prev-class="prev-item"
                      next-class="next-item"
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </div>

            </div>
          </div>
          <div class="d-flex w-100 justify-content-end pt-3">
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="secondary"
              @click="hideModal"
              class="mr-sm-1 mobile-w100"
            >
              取消
            </b-button>
          </div>
        </b-card-body>
      </b-card>
    </b-modal>

    <!-- 破產記錄詳情 Modal -->
    <b-modal
      id="modal-bankruptcy-details"
      v-model="bankruptcyModalVisible"
      hide-footer
      hide-header
      centered
      size="xl"
      title=""
      @hide="closeBankruptcyModal"
    >
      <b-card no-body class="bgColor3 mt-1">
        <b-card-body class="p-3" style="position: relative; overflow: hidden;">
          <div class="bankruptcy-modal-bg" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 1; background-image: url(/img/logo.d1331e1f.png); background-size: 350px 120px; background-repeat: space; background-position: center; opacity: 0.05; filter: grayscale(100%) brightness(3) contrast(150%);">
          </div>
          <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 2;""></div>

          <div class="d-flex justify-content-between align-items-center mb-3">
            <div style="z-index: 30; position: relative;">
              <h5 class="mb-1" style="color: #fff;">
                公共紀錄資料
              </h5>
              <h6 class="mb-0" style="color: #fff; font-weight: normal; opacity: 0.9;">
                {{ bankruptcyInfo ? bankruptcyInfo.id_prefix : '' }} 可能相關的破產記錄(請自行判斷是否屬同一人士。)
              </h6>
            </div>
            <b-button
              variant="outline-light"
              size="sm"
              @click="closeBankruptcyModal"
              style="z-index: 30; position: relative;"
            >
              <feather-icon icon="XIcon" size="16" />
            </b-button>
          </div>

          <!-- 載入狀態 -->
          <div v-if="bankruptcyDetailLoading" class="text-center py-5">
            <b-spinner variant="light" style="width: 3rem; height: 3rem;"></b-spinner>
            <div class="mt-2" style="color: #fff; z-index: 30; position: relative;">載入中...</div>
          </div>

          <!-- 破產記錄表格 -->
          <div v-else-if="bankruptcyDetailRecords.length > 0">
            <b-table
              :items="bankruptcyDetailRecords"
              :fields="bankruptcyTableFields"
              responsive
              striped
              bordered
              hover
              class="position-relative bankruptcy-table"
              style="z-index: 20; background-color: white; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 10px rgba(0,0,0,0.1);"
              show-empty
              empty-text="未找到匹配的記錄"
            >
              <template #cell(name)="data">
                <div style="z-index: 30; position: relative; padding: 12px 8px; font-weight: 600; color: #2c3e50;">
                  {{ data.item.name }}
                </div>
              </template>
              <template #cell(name_en)="data">
                <div style="z-index: 30; position: relative; padding: 12px 8px; font-weight: 600; color: #2c3e50;" v-if="data.item.name_en">
                  {{ data.item.name_en }}
                </div>
                <div style="z-index: 30; position: relative; padding: 12px 8px; color: #6c757d; font-style: italic;" v-else>
                  -
                </div>
              </template>
              <template #cell(court_order)="data">
                <div style="z-index: 30; position: relative; padding: 12px 16px; font-weight: 500; color: #34495e; line-height: 1.6;">
                  根據香港高等法院破產法律程序頒布破產令 <strong>{{ data.item.year }}年第{{ data.item.case_number }}宗</strong> 法庭命令
                </div>
              </template>
            </b-table>
          </div>

          <!-- 無記錄 -->
          <div v-else class="text-center py-5">
            <div style="color: #fff; z-index: 30; position: relative;">未找到相關破產記錄</div>
          </div>


          <div class="d-flex justify-content-end mt-3">
            <b-button
              variant="secondary"
              @click="closeBankruptcyModal"
              style="z-index: 30; position: relative;"
            >
              關閉
            </b-button>
          </div>
        </b-card-body>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import axiosIns from "@/libs/axios";
import {
  BModal,
  BButton,
  BTable,
  BCardBody,
  BCard,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";

import { mapGetters } from "vuex";

import ModalLoanEdit from "../../../loan/modal/ModalLoanEdit.vue";
import ModalAddReject from "./ModalAddReject.vue";
import ModalAddAccount from "./ModalAddAccount.vue";
import { ref, watch, computed, onMounted } from "@vue/composition-api";

export default {
  components: {
    BModal,
    BButton,
    BTable,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    ModalLoanEdit,
    ModalAddReject,
    ModalAddAccount,
  },
  data() {
    return {
      inEdit: 0,
      isRejectEdit: false,
      rejectData: {},
      rejectLogs: [],
      isAccountEdit: false,
      accountData: {},
      accountLogs: [],
      // 破產記錄相關
      bankruptcyInfo: null,
      bankruptcyLoading: false,
      bankruptcyModalVisible: false,
      bankruptcyDetailRecords: [],
      bankruptcyDetailLoading: false,
      bankruptcyTableFields: [
        { key: "name_en", label: "債務人(英)", sortable: true, thStyle: { width: "20%", textAlign: "center", backgroundColor: "#f8f9fa" }, tdClass: "text-center align-middle" },
        { key: "name", label: "債務人(中)", sortable: true, thStyle: { width: "20%", textAlign: "center", backgroundColor: "#f8f9fa" }, tdClass: "text-center align-middle" },
        { key: "court_order", label: "", sortable: false, thStyle: { width: "60%", textAlign: "center", backgroundColor: "#f8f9fa" }, tdClass: "text-left align-middle" },
      ],
      rejectTableColumns: [
        { key: "record_date", label: "時間" },
        { key: "supplier.company_name_cn", label: "財務公司" },
        { key: "reject_option", label: "拒絕狀態" },
        { key: "remark", label: "備註" },
        { key: "status.name", label: "狀態" },
        { key: "actions", label: "操作" },
      ],
      loanTableColumns: [
        { key: "loan_date", label: "借貸日期" },
        { key: "supplier.company_name_cn", label: "銀行/財務機構" },
        { key: "amount", label: "貸款本金" },
        // { key: "min_paid", label: "每月/最低供款" },
        { key: "period", label: "總期數" },
        { key: "is_monthly", label: "供款週期" },
      ],
      accountTableColumns: [
        { key: "record_date", label: "時間" },
        { key: "supplier.company_name_cn", label: "財務公司" },
        { key: "account_option", label: "帳務狀態" },
        { key: "remark", label: "備註" },
        { key: "status.name", label: "狀態" },
        { key: "actions", label: "操作" },
      ],
      // Hide
      statisticTableColumns: [
        { key: "company_name_cn", label: "財務公司" },
        { key: "weekly", label: "7天" },
        { key: "monthly", label: "一個月" },
        { key: "biannual", label: "半年" },
      ],

      // Hide
      searchDetailColumns: [
        { key: "search_date", label: "搜尋時間" },
        { key: "supplier.company_name_cn", label: "銀行/財務機構" },
        { key: "cc", label: "" },
        { key: "ss", label: "" },
      ],

      newSearchDetailColumns: [
        { key: "date", label: "搜尋時間" },
        { key: "supplier", label: "銀行/財務機構" },
        { key: "accumulate_numbers", label: "累計次數" },
        { key: "show_details", label: "顯示全部 ", sortable: true },
      ],
      // Hide
      totalWeekly: null,
      // Hide
      totalMonthly: null,
      // Hide
      totalBiannual: null,
      // 最終選定的水印顏色
      testColors: {
        odd: "#858585", // 奇數水印 - 中灰色
        even: "#545454", // 偶數水印 - 深灰色
      },
      testOpacity: {
        odd: 0.4, // 奇數水印透明度
        even: 0.4, // 偶數水印透明度
      },
    };
  },
  computed: {
    ...mapGetters("app", [
      "user_supplier_id",
      "user_company_name_cn",
      "user_contact_name",
      "user_id",
    ]),

    // 獲取供應商名稱
    getSupplierName() {
      // 優先使用當前用戶的公司名稱
      if (this.user_company_name_cn) {
        return this.user_company_name_cn;
      }
      // 如果沒有，嘗試從 pdfData 中獲取
      if (
        this.pdfData &&
        this.pdfData.supplier &&
        this.pdfData.supplier.company_name_cn
      ) {
        return this.pdfData.supplier.company_name_cn;
      }
      return "供應商";
    },

    // 獲取搜索者信息
    getSearcherInfo() {
      // 優先使用聯絡人姓名
      if (this.user_contact_name) {
        return this.user_contact_name;
      }
      // 如果沒有，只返回用戶ID (不帶 "ID:" 前綴)
      return this.user_id ? `${this.user_id}` : "用戶";
    },

    // 動態計算水印數量 - 超大密度確保完全覆蓋動態頁面
    dynamicWatermarkCount() {
      if (!this.pdfData) return 800;

      // 計算內容項目總數
      const rejectCount = this.pdfData.reject_records
        ? this.pdfData.reject_records.length
        : 0;
      const loanCount = this.pdfData.loan_record
        ? this.pdfData.loan_record.length
        : 0;
      const accountCount = this.pdfData.account_records
        ? this.pdfData.account_records.length
        : 0;
      const searchCount = this.pdfData.new_search_records
        ? this.pdfData.new_search_records.length
        : 0;

      const totalRecords = rejectCount + loanCount + accountCount + searchCount;

      // 超大基礎水印數量確保完全覆蓋動態增長的頁面
      let baseCount = 800;

      // 根據記錄數量動態調整 - 確保超密集覆蓋
      if (totalRecords === 0) {
        // 無數據時也要有足夠密度
        baseCount = 600;
      } else if (totalRecords <= 5) {
        // 極少數據
        baseCount = 700;
      } else if (totalRecords <= 10) {
        // 少量數據
        baseCount = 800;
      } else if (totalRecords <= 20) {
        // 中少數據
        baseCount = 1000;
      } else if (totalRecords <= 30) {
        // 中等數據
        baseCount = 1200;
      } else if (totalRecords <= 50) {
        // 較多數據
        baseCount = 1400;
      } else {
        // 大量數據 - 最多可達2000個水印
        baseCount = Math.min(2000, 800 + Math.floor(totalRecords * 4));
      }

      return baseCount;
    },
  },
  directives: {
    Ripple,
  },
  props: {
    getPdfData: {
      type: Object,
      required: true,
    },
    ability: {
      type: Object,
      required: true,
    },
    number_of_search: {
      type: Number,
      required: true,
    },
    number_of_loan: {
      type: Number,
      required: true,
    },
  },
  methods: {
    hideModal() {
      this.$root.$emit("bv::hide::modal", "modal-PDF", "#btnShow");
    },

    // Modal 打開時的處理（現在不需要更新快照，因為在打開前已經更新了）
    onModalShow() {
      // 重置破產記錄狀態
      this.bankruptcyInfo = null;
      this.bankruptcyLoading = false;

      if (this.pdfData && this.pdfData.id) {
        // 快照已在打開 modal 前更新，這裡不需要再次更新

        // 延遲查詢破產記錄，確保 modal 已完全打開且 pdfData 完全載入
        this.$nextTick(() => {
          setTimeout(() => {
            console.log('Modal 打開後查詢破產記錄, pdfData:', this.pdfData);
            this.fetchBankruptcyRecords();
          }, 100);
        });
      } else {
        console.log('onModalShow: pdfData 未準備好', this.pdfData);
        // 如果 pdfData 還沒準備好，等待一段時間後再試
        setTimeout(() => {
          if (this.pdfData && this.pdfData.id) {
            console.log('延遲後 pdfData 已準備好，查詢破產記錄');
            this.fetchBankruptcyRecords();
          }
        }, 500);
      }
    },

    // 查詢破產記錄
    async fetchBankruptcyRecords() {
      console.log('fetchBankruptcyRecords 被調用, pdfData:', this.pdfData);

      if (!this.pdfData || !this.pdfData.client || !this.pdfData.client.id_number) {
        console.log('pdfData 或 client 資料不完整');
        this.bankruptcyInfo = null;
        return;
      }

      const idNumber = this.pdfData.client.id_number;
      console.log('身份證號碼:', idNumber);

      // 提取身份證前4位，支援各種格式
      const idPrefix = idNumber.substring(0, 4).toUpperCase();
      console.log('身份證前4位:', idPrefix);

      // 驗證格式（必須是4位字母數字組合）
      if (!/^[A-Z0-9]{4}$/.test(idPrefix)) {
        console.log('身份證前4位格式不正確');
        this.bankruptcyInfo = null;
        return;
      }

      this.bankruptcyLoading = true;
      console.log('開始查詢破產記錄，id_prefix:', idPrefix);

      try {
        const response = await this.$store.dispatch('app/fetchBankruptcyByPrefix', {
          id_prefix: idPrefix
        });

        if (response && response.data && response.data.success) {
          this.bankruptcyInfo = response.data.data;
        } else {
          this.bankruptcyInfo = null;
        }
      } catch (error) {
        this.bankruptcyInfo = null;
      } finally {
        this.bankruptcyLoading = false;
      }
    },

    // 顯示破產記錄詳情modal
    showBankruptcyModal() {
      if (!this.bankruptcyInfo || !this.bankruptcyInfo.id_prefix) {
        return;
      }

      this.bankruptcyModalVisible = true;
      this.fetchBankruptcyDetailRecords();
    },

    // 獲取破產記錄詳細列表
    async fetchBankruptcyDetailRecords() {
      if (!this.bankruptcyInfo || !this.bankruptcyInfo.id_prefix) {
        return;
      }

      this.bankruptcyDetailLoading = true;

      try {
        const response = await this.$store.dispatch('app/fetchBankruptcyList', {
          q: this.bankruptcyInfo.id_prefix,
          perPage: 50 // 一次加載更多記錄
        });

        if (response && response.data && response.data.success) {
          this.bankruptcyDetailRecords = response.data.data || [];
        } else {
          this.bankruptcyDetailRecords = [];
        }
      } catch (error) {
        this.bankruptcyDetailRecords = [];
      } finally {
        this.bankruptcyDetailLoading = false;
      }
    },

    // 關閉破產記錄modal
    closeBankruptcyModal() {
      this.bankruptcyModalVisible = false;
      this.bankruptcyDetailRecords = [];
    },
    // calcateTotal() {
    //   this.totalWeekly = this.pdfData.statistic_record.reduce(
    //     (accumulator, object) => {
    //       return accumulator + object.weekly;
    //     },
    //     0
    //   );
    //   this.totalMonthly = this.pdfData.statistic_record.reduce(
    //     (accumulator, object) => {
    //       return accumulator + object.monthly;
    //     },
    //     0
    //   );
    //   this.totalBiannual = this.pdfData.statistic_record.reduce(
    //     (accumulator, object) => {
    //       return accumulator + object.biannual;
    //     },
    //     0
    //   );
    // },
    triggerAddReject() {
      this.isRejectEdit = false;
      this.rejectLogs = [];
      this.rejectData = {};
      this.$bvModal.show(`modal-add-reject`);
    },
    triggerEditReject(item) {
      this.isRejectEdit = true;
      this.rejectData = item;

      this.$store
        .dispatch("app/getEditRejectRecord", { id: item.id })
        .then((response) => {
          this.rejectLogs = response.data.client_reject_record.supplier_logs;
          this.$bvModal.show(`modal-add-reject`);
        })
        .catch((error) => {
          this.$swal({
            text: JSON.stringify(error.response.data.message),
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        });
    },
    triggerAddAccount() {
      this.isAccountEdit = false;
      this.accountLogs = [];
      this.accountData = {};
      this.$bvModal.show(`modal-add-account`);
    },
    triggerEditAccount(item) {
      this.isAccountEdit = true;
      this.accountData = item;

      this.$store
        .dispatch("app/getEditAccountRecord", { id: item.id })
        .then((response) => {
          this.accountLogs = response.data.client_account_record.supplier_logs;
          this.$bvModal.show(`modal-add-account`);
        })
        .catch((error) => {
          this.$swal({
            text: JSON.stringify(error.response.data.message),
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        });
    },
    triggerCreateLoan() {
      this.$bvModal.show(`modal-loan-edit${this.inEdit}`);
    },
    refetchNewestData(id) {
      // 調用快照更新 API，只補回自己的新記錄
      this.updateSnapshot(id);
    },

    // 更新快照（只補回自己 supplier_id 的新記錄）
    updateSnapshot(searchRecordId, showToast = true) {
      console.log("開始更新快照...", searchRecordId);

      this.$store
        .dispatch("app/updateSearchRecordSnapshot", {
          search_record_id: searchRecordId,
        })
        .then((response) => {
          console.log("快照更新成功", response.data);

          if (response.data.search_record) {
            // 更新 pdfData 為最新的快照資料
            this.pdfData = response.data.search_record;
            console.log("pdfData 已更新");

            // pdfData 更新後查詢破產記錄
            this.fetchBankruptcyRecords();

            // 同時更新搜尋次數和貸款次數統計
            if (response.data.number_of_search !== undefined) {
              this.$emit("update-search-count", response.data.number_of_search);
            }
            if (response.data.number_of_loan !== undefined) {
              this.$emit("update-loan-count", response.data.number_of_loan);
            }
          }

          // 只在需要時顯示成功提示
          if (showToast) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "成功",
                text: "記錄已更新",
                icon: "CheckIcon",
                variant: "success",
              },
            });
          }
        })
        .catch((error) => {
          console.error("更新快照失敗:", error);

          // 如果快照更新失敗，回退到原本的重新 fetch 邏輯
          this.$emit("refetch-newest-data", searchRecordId);
        });
    },
    refetchSupplierInfo() {
      this.$emit("refetch-supplier-info");
    },
    removeItem(key, item) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let url = "";
          if (key == "reject") {
            url = "deleteRejectRecord";
          } else {
            url = "deleteAccountRecord";
          }
          this.$store
            .dispatch("app/" + url, { id: item.id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              // 直接調用快照更新，而不是發出事件
              this.updateSnapshot(this.pdfData.id);
            })
            .catch((error) => {
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    buyExtraRecords(isExtraLoan) {
      let msg = "";
      let tem = this.$store.state.app.user_info.info;
      const supplier = this.$store.state.app.supplier_info;

      // 檢查是使用免費搜尋次數還是 X Coin
      const useSearchLimit = supplier && supplier.search_limit > 0;

      let coin = 0;
      if (isExtraLoan) {
        coin = Number(tem.coin_extra_records);
      } else {
        coin = Number(tem.coin_extra_search_records);
      }

      if (useSearchLimit) {
        // 使用免費搜尋次數
        msg += `是否確認使用1次免費搜尋次數購買額外`;
      } else {
        // 使用 X Coin
        msg += `是否確認使用${coin} X Coins購買額外`;
      }

      if (isExtraLoan) {
        msg += `個人財務狀況`;
      } else {
        msg += `查詢紀錄`;
      }

      // 添加提示信息
      if (useSearchLimit) {
        msg += `\n(將扣除1次免費搜尋次數)`;
      } else {
        msg += `\n(將扣除${coin} X Coin)`;
      }

      this.$swal({
        title: "",
        text: msg,
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          const supplier = this.$store.state.app.supplier_info;
          const useSearchLimit = supplier && supplier.search_limit > 0;

          let obj;
          if (isExtraLoan) {
            obj = {
              id: this.pdfData.id,
              all_record_bit: 1,
              use_search_limit: useSearchLimit, // 添加使用搜尋次數的標誌
            };
          } else {
            obj = {
              id: this.pdfData.id,
              all_search_record_bit: 1,
              use_search_limit: useSearchLimit, // 添加使用搜尋次數的標誌
            };
          }

          console.log("購買額外記錄參數:", obj);

          this.$store
            .dispatch("app/extraRecord", obj)
            .then((response) => {
              this.loading = false;
              if (response.data.search_record) {
                this.pdfData = response.data.search_record;

                // pdfData 更新後查詢破產記錄
                this.fetchBankruptcyRecords();
              }

              // 更新 Coin 餘額和搜尋次數
              this.$store.dispatch("app/fetchCoinsBalance");
              this.$store.dispatch("app/fetchSupplierInfo");

              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-newest-data", this.pdfData.id);
            })
            .catch((error) => {
              this.loading = false;
              console.log(error);
              
              // 檢查是否為放債人牌照相關錯誤
              const errorMessage = error.response?.data?.message || "操作失敗";
              
              if (errorMessage.includes("放債人牌照") || 
                  errorMessage.includes("moneylender") ||
                  errorMessage.includes("license")) {
                
                // 先檢查是否有未批准的記錄
                this.checkPendingRequestAndShowModal(errorMessage);
              } else {
                // 一般錯誤處理
                this.$swal({
                  text: JSON.stringify(errorMessage),
                  icon: "error",
                  confirmButtonText: "確定",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  showClass: {
                    popup: "animate__animated animate__bounceIn",
                  },
                  buttonsStyling: false,
                });
              }
            });
        }
      });
    },
    deleteLine(item, type) {
      if (item && type === "row") {
        if (item.status.id == 2) {
          return "delete-line";
        } else {
          return "";
        }
      } else {
        return null;
      }
    },

    // 計算網格水印位置 - 優化間距避免重疊
    getDiagonalPosition(index) {
      // 優化網格排列參數 - 避免重疊
      const horizontalSpacing = 140; // 增加水平間距避免重疊
      const verticalSpacing = 60; // 增加垂直間距
      const itemsPerRow = 15; // 適中的每行水印數量

      // 計算當前水印在網格中的位置
      const row = Math.floor((index - 1) / itemsPerRow);
      const col = (index - 1) % itemsPerRow;

      // 計算基礎網格位置，從負座標開始確保完全覆蓋
      const x = col * horizontalSpacing - 500; // 大幅向左擴展起始位置
      const y = row * verticalSpacing - 300; // 大幅向上擴展起始位置

      return {
        position: "absolute",
        left: `${x}px`,
        top: `${y}px`,
        transform: "rotate(45deg)",
        zIndex: 7,
      };
    },

    // 獲取水印顏色 - 測試用
    getWatermarkColor(index) {
      const isOdd = index % 2 === 1;
      const color = isOdd ? this.testColors.odd : this.testColors.even;
      const opacity = isOdd ? this.testOpacity.odd : this.testOpacity.even;

      // 將 hex 顏色轉換為 rgba
      const hex = color.replace("#", "");
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);

      return {
        color: `rgba(${r}, ${g}, ${b}, ${opacity}) !important`,
        textShadow: "1px 1px 2px rgba(255, 255, 255, 0.5)",
      };
    },

    // 更新水印顏色
    updateWatermarkColors() {
      // 強制重新渲染水印
      this.$forceUpdate();
    },

    // 重置顏色 (重置為最終選定的顏色)
    resetColors() {
      this.testColors.odd = "#858585"; // 奇數水印 - 中灰色
      this.testColors.even = "#545454"; // 偶數水印 - 深灰色
      this.testOpacity.odd = 0.4;
      this.testOpacity.even = 0.4;
      this.updateWatermarkColors();
    },

    checkPendingRequestAndShowModal(licenseMessage) {
      // 檢查是否有未批准的記錄
      axiosIns.get("/supplier_change_request/check-pending")
        .then(response => {
          if (response.data.hasPending) {
            // 有未處理的申請，顯示提示但不開啟modal
            this.$swal({
              title: "放債人牌照問題",
              text: response.data.message,
              icon: "info",
              confirmButtonText: "知道了",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              showClass: {
                popup: "animate__animated animate__bounceIn",
              },
              buttonsStyling: false,
            });
          } else {
            // 沒有未處理的申請，可以開啟modal
            this.$swal({
              title: "放債人牌照問題",
              text: licenseMessage,
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "更新牌照資料",
              cancelButtonText: "稍後處理",
              customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-outline-secondary ml-1",
              },
              showClass: {
                popup: "animate__animated animate__bounceIn",
              },
              buttonsStyling: false,
            }).then((result) => {
              if (result.value) {
                // 打開放債人牌照更新modal
                this.$bvModal.show("modal-edit-moneylender-number");
              }
            });
          }
        })
        .catch(error => {
          console.error("Failed to check pending request:", error);
          // 如果檢查失敗，直接顯示更新選項
          this.$swal({
            title: "放債人牌照問題",
            text: licenseMessage,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "更新牌照資料",
            cancelButtonText: "稍後處理",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-secondary ml-1",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.value) {
              this.$bvModal.show("modal-edit-moneylender-number");
            }
          });
        });
    },
  },
  setup(props) {
    const pdfData = ref(null);

    watch(
      () => props.getPdfData,
      (newVal) => {
        pdfData.value = newVal;

        if (
          pdfData.value.new_search_records &&
          pdfData.value.new_search_records.length > 0 &&
          pdfData.value.search_record &&
          pdfData.value.search_record.length > 0
        ) {
          pdfData.value.new_search_records =
            pdfData.value.new_search_records.map((item) => {
              const search_record = pdfData.value.search_record.filter(
                (ele) => ele.supplier_id === item.supplier_id
              );
              return { ...item, ...{ search_records: search_record } };
            });
          pdfData.value = { ...pdfData.value, new_search_records_forRef: [] };
          pdfData.value.new_search_records_forRef =
            pdfData.value.new_search_records;
        }
      },
      { immediate: true }
    );
    // reject page change option
    const rejectCurrentPage = ref(1);
    const rejectPerPage = ref(10);
    const totalRejects = ref(0);

    const refRejectRecordTable = ref(null);

    const rejectDataMeta = computed(() => {
      const localItemsCount = refRejectRecordTable.value
        ? refRejectRecordTable.value.localItems.length
        : 0;
      return {
        from:
          rejectPerPage.value * (rejectCurrentPage.value - 1) +
          (localItemsCount ? 1 : 0),
        to:
          rejectPerPage.value * (rejectCurrentPage.value - 1) + localItemsCount,
        of: totalRejects.value,
      };
    });

    // loan page change option
    const loanCurrentPage = ref(1);
    const loanPerPage = ref(10);
    const totalLoans = ref(0);

    const refSearchLoanTable = ref(null);

    const loanDataMeta = computed(() => {
      const localItemsCount = refSearchLoanTable.value
        ? refSearchLoanTable.value.localItems.length
        : 0;
      return {
        from:
          loanPerPage.value * (loanCurrentPage.value - 1) +
          (localItemsCount ? 1 : 0),
        to: loanPerPage.value * (loanCurrentPage.value - 1) + localItemsCount,
        of: totalLoans.value,
      };
    });

    // account page change option
    const accountCurrentPage = ref(1);
    const accountPerPage = ref(10);
    const totalAccounts = ref(0);

    const refAccountRecordTable = ref(null);

    const accountDataMeta = computed(() => {
      const localItemsCount = refAccountRecordTable.value
        ? refAccountRecordTable.value.localItems.length
        : 0;
      return {
        from:
          accountPerPage.value * (accountCurrentPage.value - 1) +
          (localItemsCount ? 1 : 0),
        to:
          accountPerPage.value * (accountCurrentPage.value - 1) +
          localItemsCount,
        of: totalAccounts.value,
      };
    });

    // detail page change option
    const detailCurrentPage = ref(1);
    const detailPerPage = ref(10);
    const totalDetails = ref(0);

    const refSearchDetailTable = ref(null);

    const detailDataMeta = computed(() => {
      const localItemsCount = refSearchDetailTable.value
        ? refSearchDetailTable.value.localItems.length
        : 0;
      return {
        from:
          detailPerPage.value * (detailCurrentPage.value - 1) +
          (localItemsCount ? 1 : 0),
        to:
          detailPerPage.value * (detailCurrentPage.value - 1) + localItemsCount,
        of: totalDetails.value,
      };
    });

    const refetchTbData = (total, meta, perPage, current, target) => {
      total.value = props.getPdfData[target].length;
      const min = Number(meta.value.from - 1);
      const max = Number(perPage.value * current.value - 1);
      if (target !== "new_search_record") {
        pdfData.value[target] = props.getPdfData[target].filter(
          (ele, index) => index >= min && index <= max
        );
      } else {
        if (pdfData.value.hasOwnProperty("new_search_records_forRef")) {
          pdfData.value[target] =
            pdfData.value.new_search_records_forRef.filter(
              (ele, index) => index >= min && index <= max
            );
        }
      }
    };

    watch(
      [
        rejectCurrentPage,
        loanCurrentPage,
        accountCurrentPage,
        detailCurrentPage,
        pdfData,
      ],
      () => {
        refetchTbData(
          totalRejects,
          rejectDataMeta,
          rejectPerPage,
          rejectCurrentPage,
          "reject_records"
        );
        refetchTbData(
          totalLoans,
          loanDataMeta,
          loanPerPage,
          loanCurrentPage,
          "loan_record"
        );
        refetchTbData(
          totalAccounts,
          accountDataMeta,
          accountPerPage,
          accountCurrentPage,
          "account_records"
        );
        refetchTbData(
          totalDetails,
          detailDataMeta,
          detailPerPage,
          detailCurrentPage,
          "new_search_records"
        );
      }
    );

    return {
      pdfData,
      refRejectRecordTable,
      rejectDataMeta,
      rejectCurrentPage,
      rejectPerPage,
      totalRejects,

      refSearchLoanTable,
      loanDataMeta,
      loanCurrentPage,
      loanPerPage,
      totalLoans,

      refAccountRecordTable,
      accountDataMeta,
      accountCurrentPage,
      accountPerPage,
      totalAccounts,

      refSearchDetailTable,
      detailDataMeta,
      detailCurrentPage,
      detailPerPage,
      totalDetails,
    };
    //
  },
};
</script>

<style lang="scss">
.delete-line {
  position: relative;
  td:first-child {
    position: relative;
    &:after {
      content: "";
      position: absolute;
      top: 25px;
      left: 40px;
      width: 90vw;
      max-width: 780px;
      height: 2px;
      background-color: #000000;
    }
  }
}
#modal-PDF {
  user-select: none;
  padding-left: 15px;
  padding-right: 15px;
  color: #fff;
  // overflow:hidden;
  .modal-dialog {
    max-width: 1000px;
    overflow: hidden;
  }
  .bg-logo {
    width: 3000px;
    height: 3000px;
    left: -1000px;
    top: 0px;
    position: absolute;
    opacity: 0.1;
    background-image: url("~@/assets/images/logo/logo.png");
    background-repeat: round;
    z-index: 0;
    transform: rotate(45deg);
  }

  /* 水印樣式 */
  .watermark-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none; /* 確保水印不會影響用戶交互 */
    z-index: 8; /* 降低 z-index 但確保在表格上方 */
    overflow: hidden;
  }

  /* 網格水印容器 - 超大範圍覆蓋動態頁面 */
  .diagonal-pattern {
    position: absolute;
    top: -500px; /* 超大向上擴展 */
    left: -500px; /* 超大向左擴展 */
    width: calc(100% + 3000px); /* 超大寬度確保完全覆蓋 */
    height: calc(100% + 2500px); /* 超大高度確保覆蓋動態增長的頁面 */
    z-index: 7; /* 確保在表格上方 */
    pointer-events: none; /* 確保不阻擋點擊 */
    overflow: hidden;
  }

  .diagonal-item {
    position: absolute;
    display: block;
    width: 130px; /* 增大寬度容納更大字體 */
    height: 40px; /* 增加高度 */
    pointer-events: none;
  }

  .diagonal-text {
    font-size: 14px; /* 增大字體 */
    text-align: center;
    white-space: nowrap;
    user-select: none;
    pointer-events: none;
    font-weight: bold;
    line-height: 1;
    display: block;
  }

  /* 奇數水印 - 第一種顏色 (藍色調) */
  .watermark-odd .diagonal-text {
    color: rgba(135, 133, 78, 0.4) !important; /* 深藍色，增強可見性 */
    text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.5); /* 添加白色陰影增強對比 */
  }

  /* 偶數水印 - 第二種顏色 (橙紅色調) */
  .watermark-even .diagonal-text {
    color: rgba(167, 176, 100, 0.4) !important; /* 橙紅色，增強可見性 */
    text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.5); /* 添加白色陰影增強對比 */
  }

  /* 按鈕樣式 - 確保可點擊 */
  button,
  .btn {
    z-index: 30 !important; /* 提高 z-index 確保按鈕在水印上方 */
    position: relative;
    pointer-events: auto !important; /* 確保按鈕可點擊 */
  }

  /* 下拉菜單樣式 */
  .b-dropdown {
    z-index: 35 !important;
    position: relative;
  }

  .dropdown-menu {
    z-index: 40 !important;
  }

  /* 表格樣式 - 增強水印透過表格的可見性 */
  .b-table {
    position: relative;
    z-index: 10; /* 降低表格 z-index 讓水印顯示在上方 */
    background: transparent !important; /* 確保背景透明 */
  }

  .b-table table {
    background: transparent !important;
  }

  .b-table tbody tr {
    background: rgba(
      255,
      255,
      255,
      0.3
    ) !important; /* 更透明的背景讓水印更容易顯示 */
    position: relative;
  }

  .b-table tbody tr:hover {
    background: rgba(255, 255, 255, 0.4) !important; /* 懸停時稍微不透明 */
  }

  .b-table thead th {
    background: rgba(255, 255, 255, 0.6) !important; /* 表頭背景更透明 */
    z-index: 12;
    position: relative;
  }

  /* 確保表格單元格也有透明度 */
  .b-table tbody td {
    background: rgba(255, 255, 255, 0.2) !important; /* 單元格更透明背景 */
  }

  /* 分頁樣式 */
  .b-pagination {
    position: relative;
    z-index: 25;
  }

  /* 確保所有可點擊元素都在水印上方 */
  .action-trigger-btn {
    z-index: 35 !important;
    position: relative;
  }

  /* 表格內的按鈕和鏈接 */
  .b-table td button,
  .b-table td .btn,
  .b-table td .b-dropdown {
    z-index: 35 !important;
    position: relative;
  }

  /* 分頁按鈕 */
  .b-pagination .page-link {
    z-index: 30 !important;
    position: relative;
  }

  .bad-debts {
    display: inline-block;
    color: #fff;
    background-color: #ea5455;
    padding: 0.5rem 1.25rem;
    font-size: 1rem;
    border-radius: 0;
    z-index: 20;
    position: relative;
  }

  // 破產記錄顯示樣式
  .bankruptcy-info-text {
    
    color: #ea5455;
    color: black;
    font-weight: 400;
    font-size: 14px;
    z-index: 25;
    position: relative;
    cursor: pointer;
    transition: all 0.2s ease;
    text-decoration: none;
    text-align: center;
    &:hover {
      color: #ff3838;
      text-decoration: underline;
    }

    &:active {
      color: #d63384;
    }
  }

  /* 破產記錄 Modal 背景設計 */
  .bankruptcy-modal-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    overflow: hidden;
    border-radius: 8px;
  }

  .bg-gradient-layer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(52, 73, 94, 0.95) 0%,
      rgba(44, 62, 80, 0.98) 30%,
      rgba(28, 40, 51, 0.99) 70%,
      rgba(52, 73, 94, 0.95) 100%
    );
    z-index: 2;
  }

  .bg-geometric-layer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
      linear-gradient(30deg, rgba(255, 255, 255, 0.02) 12%, transparent 12.5%, transparent 87%, rgba(255, 255, 255, 0.02) 87.5%, rgba(255, 255, 255, 0.02)),
      linear-gradient(150deg, rgba(255, 255, 255, 0.02) 12%, transparent 12.5%, transparent 87%, rgba(255, 255, 255, 0.02) 87.5%, rgba(255, 255, 255, 0.02)),
      linear-gradient(30deg, rgba(255, 255, 255, 0.02) 12%, transparent 12.5%, transparent 87%, rgba(255, 255, 255, 0.02) 87.5%, rgba(255, 255, 255, 0.02)),
      linear-gradient(150deg, rgba(255, 255, 255, 0.02) 12%, transparent 12.5%, transparent 87%, rgba(255, 255, 255, 0.02) 87.5%, rgba(255, 255, 255, 0.02));
    background-size: 76px 130px;
    z-index: 3;
  }

  .bg-pattern-layer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
      radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.08) 2px, transparent 2px),
      radial-gradient(circle at 75% 75%, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
    background-size: 60px 60px, 40px 40px;
    animation: subtle-move 25s linear infinite;
    z-index: 4;
  }

  @keyframes subtle-move {
    0% { transform: translate(0, 0); }
    100% { transform: translate(60px, 60px); }
  }

  .bg-logo-subtle {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(/img/logo.d1331e1f.png);
    background-size: 200px 200px;
    background-repeat: repeat;
    background-position: 0 0, 100px 100px;
    opacity: 0.06;
    z-index: 5;
    filter: grayscale(100%) brightness(1.3) contrast(120%);
    animation: logo-drift 35s linear infinite;
  }

  @keyframes logo-drift {
    0% { background-position: 0 0, 100px 100px; }
    100% { background-position: 200px 200px, 300px 300px; }
  }

  .bg-accent-lines {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
      linear-gradient(90deg, rgba(74, 144, 226, 0.08) 1px, transparent 1px),
      linear-gradient(180deg, rgba(74, 144, 226, 0.08) 1px, transparent 1px);
    background-size: 120px 120px;
    animation: grid-slide 40s linear infinite;
    z-index: 6;
  }

  @keyframes grid-slide {
    0% { transform: translate(0, 0); }
    100% { transform: translate(120px, 120px); }
  }

  /* 確保內容在背景之上 */
  .bankruptcy-modal-bg + * {
    position: relative;
    z-index: 10;
  }

  /* 重要：確保破產記錄 modal 背景樣式生效 */
  #modal-bankruptcy-details .bankruptcy-modal-bg {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    z-index: 1 !important;
    overflow: hidden !important;
    border-radius: 8px !important;
  }

  #modal-bankruptcy-details .bg-gradient-layer {
    display: block !important;
  }

  #modal-bankruptcy-details .bg-geometric-layer {
    display: block !important;
  }

  #modal-bankruptcy-details .bg-pattern-layer {
    display: block !important;
  }

  #modal-bankruptcy-details .bg-logo-subtle {
    display: block !important;
  }

  #modal-bankruptcy-details .bg-accent-lines {
    display: block !important;
  }

  /* 浮動顏色選擇器樣式 - 測試用 */
  .floating-color-selector {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 9999;
    background: rgba(255, 255, 255, 0.95);
    border: 2px solid #ddd;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    min-width: 280px;
  }

  .color-selector-panel h6 {
    margin-bottom: 15px;
    color: #333;
    font-weight: bold;
  }

  .color-group {
    margin-bottom: 15px;
    padding: 10px;
    background: rgba(248, 249, 250, 0.8);
    border-radius: 5px;
  }

  .color-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #555;
    font-size: 13px;
  }

  .color-input-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .color-group input[type="color"] {
    width: 50px;
    height: 30px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 10px;
  }

  .color-preview {
    width: 30px;
    height: 30px;
    border: 2px solid #ddd;
    border-radius: 4px;
    margin-left: 5px;
  }

  .opacity-control {
    display: flex;
    flex-direction: column;
  }

  .opacity-control span {
    font-size: 12px;
    color: #666;
    margin-bottom: 5px;
  }

  .color-group input[type="range"] {
    width: 100%;
  }
  .search_detail_tb {
    td {
      width: 150px;
    }
    tr.b-table-details {
      > td {
        padding: 0px;
      }
      td {
        background: #d4d4d4;
      }
    }
  }
  .hidden_header {
    display: none;
  }
}
@media screen and (max-width: 991px) {
  .delete-line {
    &:after {
      content: "";
      left: 20px;
    }
  }
}
@media screen and (max-width: 575px) {
}

#modal-PDF .d-flex {
  span,
  .title-size {
    z-index: 99999;
  }
}
</style>
